import type { SVGProps } from 'react';

interface WheatIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function WheatIcon({ className, ...props }: WheatIconProps) {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M13.6381 10.9802C13.1532 9.26643 14.1441 7.80055 15.1834 6.38013C15.3316 6.23415 16.3069 7.93227 16.3814 8.08078C17.3562 10.0431 16.7994 11.674 15.3166 13.3744L17.7366 15.5533L17.2751 15.9689L14.8551 13.7899C13.1205 14.9027 11.4083 15.5821 9.37405 14.898C9.17284 14.8297 6.87178 13.8425 7.08515 13.67C8.60408 12.6925 10.22 11.8505 12.094 12.2459L13.7678 12.8109L11.3725 10.6542C10.8405 10.8267 10.366 11.1898 9.8479 11.4229C8.20494 12.1629 6.82434 12.1784 5.21979 11.4851C4.63532 11.2328 3.95168 10.9023 3.53132 10.4701C5.1215 9.50869 6.70983 8.63444 8.6403 9.07699L10.214 9.6092L7.79397 7.43022C7.02932 7.87819 6.24461 8.32106 5.38005 8.58282C3.38301 9.18902 1.52089 8.42302 -0.000674922 7.33434C1.63875 6.18959 3.40698 5.39032 5.43417 5.97919L6.70764 6.45209L5.15234 5.0517C5.11277 5.01607 4.22911 4.89416 4.04967 4.84549C1.33385 4.11411 0.381931 2.50183 0.0745929 0.0650899C2.78406 0.429821 4.55447 1.14656 5.38379 3.64425C5.43685 3.80493 5.57324 4.60146 5.61281 4.6371L7.1681 6.03748L6.51933 4.44088C6.14174 2.84598 7.1006 1.27353 8.1489 2.55939e-05C8.94804 0.923172 9.75931 2.22558 9.81534 3.43655C9.8755 4.73823 9.09012 5.97453 8.2544 7.01743L10.6744 9.19641L10.1532 8.00522C9.55075 6.219 10.5543 4.67755 11.6306 3.17934C11.9924 3.42187 12.2395 3.84975 12.4618 4.20725C13.8122 6.38007 13.5859 8.16418 11.7607 10.1745L14.2292 12.3972L13.6381 10.9802Z" fill="currentColor" />
    </svg>
  );
}
